import { Box, MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import LodgeList from "../../components/lodge-list/lodge-list.component";
import STATES_DATA from "../../data/states.json";
import React, { Component }  from 'react';

let location;

const UseLocation = () => {
  location = useLocation();
  return null;
};

const District = () => {
  UseLocation();
  const { state: stateParam, districtId, lodgeId } = useParams();
  let [district, setDistrict] = useState(
    stateParam
      ? stateParam
      : (location.state !== null && location.state.filter !== null) ? location.state.filter : 'undefined'
  );
  //let district;
  // if (location.state.filter !== undefined) {
  //   console.log("filter: ", location.state.filter);
  // }

  const updateDistrict = (value) => {
    setDistrict(value);
  };

  const handleChange = (event) => {
    console.log(event.target.value);
    updateDistrict(event.target.value);
    //district = event.target.value;
    // setDistrict(event.target.value);
    // district = event.target.value;
    // this.setState(
    //   () => {
    //     return { distric: event.target.value };
    //   },
    //   () => {}
    // );
  };

  if (location.state !== null && location.state.filter !== null) {
    // district = location.state.filter;
    // updateDistrict(location.state.filter);
    // setDistrict(location.state.filter);
    // this.setState(
    //   () => {
    //     return { distric: location.state.filter };
    //   },
    //   () => {}
    // );
  }

  const handleSelect = (event) => {
    return district;
  };
  return (
    <Box padding="20px">
      <Box>
        <h1>Lodges</h1>
        <span>
        This information is for official Sons of Norway business use only. Use of this information for solicitation or commercial purposes is a violation of the Sons of Norway privacy policy and is strictly prohibited.
        </span>
        <Box width="250px" padding="20px">
          <TextField
            label="Select Location"
            select
            fullWidth
            value={district}
            onChange={handleChange}
          >
            {STATES_DATA.map((state) => (
              <MenuItem key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#006882",
          height: "50px",
          color: "white",

        }}

      >
       
      </Box>
      <LodgeList district={district} autoOpenDistrictId={districtId} autoOpenLodgeId={lodgeId} />
    </Box>
  );
};

export default District;
